// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBLaCyonZCWLl3jecM1gD3Y2pJ3WaNA4cU",
  authDomain: "lovejss-49f0f.firebaseapp.com",
  databaseURL: "https://lovejss-49f0f-default-rtdb.firebaseio.com",
  projectId: "lovejss-49f0f",
  storageBucket: "lovejss-49f0f.appspot.com",
  messagingSenderId: "837746756716",
  appId: "1:837746756716:web:e2b87a4dc56f2969321c49",
  measurementId: "G-SLKFFBHW4Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);